import type { LevelItem } from './types';

export const createEmptyLevelDraft = (): Partial<LevelItem> => ({
  id: 0,
  levelNum: '',
  name: '',
  title: '',
  img: '',
  backgroundImg: '',
  description: '',
  notice: '',
  html: '',
  status: 0,
  auditStatus: 0,
  rejectReason: '',
  guardedAt: '',
  occupiedAt: '',
  enterNum: 0,
  messageNum: 0,
  favoriteNum: 0,
  createAt: '',
  updateAt: ''
});

export const createLevelDraftFromItem = (level: Partial<LevelItem>): Partial<LevelItem> => ({
  id: level.id || 0,
  levelNum: level.levelNum || '',
  name: level.name || '',
  title: level.title || '',
  img: level.img || '',
  backgroundImg: level.backgroundImg || '',
  description: level.description || '',
  notice: level.notice || '',
  html: level.html || '',
  status: level.status || 0,
  auditStatus: level.auditStatus || 0,
  rejectReason: level.rejectReason || '',
  guardedAt: level.guardedAt || '',
  occupiedAt: level.occupiedAt || '',
  enterNum: level.enterNum || 0,
  messageNum: level.messageNum || 0,
  favoriteNum: level.favoriteNum || 0,
  createAt: level.createAt || '',
  updateAt: level.updateAt || ''
});
